import { render, staticRenderFns } from "./CoinStoreSendCoins.vue?vue&type=template&id=1adcafc3&scoped=true&"
import script from "./CoinStoreSendCoins.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreSendCoins.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreSendCoins.vue?vue&type=style&index=0&id=1adcafc3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adcafc3",
  null
  
)

export default component.exports